export const LOAN_INPUT_STEPPER_DELTA = 500
export const LOAN_MAX_TERM = 52
export const LOAN_MIN_TERM = 17

export const promotionalAlertConstants = {
  confirm: 'Confirm',
  cancel: 'Cancel',
}

export enum promotionType {
  FEE_WAIVER = 'FEE_WAIVER',
}
